import _ from 'lodash'

export default {
  getFranchiseName: state => id => { // Receives a role id
    if (state.franchises.length > 0) {
      const franchie = _.find(state.franchises, { id: id })
      return franchie ? franchie.name : 'Sin unidad de Negocio'
    }
    return ''
  }
}
